/** @format */

import { CustomContainer } from '@/views/Article';
import { Document } from '@contentful/rich-text-types';
import { FunctionComponent as FC, useContext } from 'react';
import { ThemeContext } from 'styled-components';
import { ContainerWrapper } from '../ui/Layout';
import { RichText } from '../ui/RichText';

export const UtilityPageBody: FC<Props> = ({ body }) => {
  const theme = useContext(ThemeContext);
  return (
    <ContainerWrapper as="section" $color={theme?.color.white}>
      <CustomContainer>
        <RichText text={body} />
      </CustomContainer>
    </ContainerWrapper>
  );
};

type Props = {
  body: Document;
};
